import { render, staticRenderFns } from "./SocialAccount.vue?vue&type=template&id=10dc2009&"
import script from "./SocialAccount.vue?vue&type=script&lang=js&"
export * from "./SocialAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports